import styled from 'styled-components';

export const WarrantyInfo = styled.ul`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  background-color: var(--cvna-color-grey-1);
  border-radius: 3px;
  padding: 4px 8px 4px 20px;
  flex-direction: column;
  list-style: none;
  margin: 20px 0 0;
  width: 100%;
  align-items: center;

  /* Desktop */
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    align-items: unset;

    margin: 4px 0 0;
    padding: 2px 16px;
    width: unset;
  }
`;

export const MonthsRemaining = styled.li`
  color: #183558;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding-right: 2px;
  }
`;

export const TextDivider = styled(MonthsRemaining)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    display: flex;
    padding: 0;
  }
`;

export const MilesRemaining = styled.li`
  color: #183558;
  text-transform: capitalize;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-transform: unset;
    padding-left: 2px;
  }
`;

export const WarrantyDetailsHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    width: unset;
    justify-content: unset;
  }

  /* Tablet */
  @media (max-width: ${(props) => props.theme.breakpoint.lg}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
